import { Flex, Text, useTheme } from "@aws-amplify/ui-react";
import React from "react";

export function Footer() {
    const { tokens } = useTheme();

    return (
        <Flex padding={tokens.space.medium} style={{ textAlign: 'center' , marginTop: '10px'}}>
            <Text>&copy; All Rights Reserved</Text>
        </Flex>
    );
}
